import { createAction } from 'typesafe-actions';
import { UpdateStatus } from './reducer';
import {
  ACTION_OPEN_UPDATE_MODAL,
  ACTION_CLOSE_UPDATE_MODAL,
  ACTION_SET_AVAILABLE_VERSIONS,
  ACTION_SELECT_VERSION,
  ACTION_START_COMPATIBILITY_CHECK,
  ACTION_SET_UPDATE_STATUS,
  ACTION_SET_FORCE_UPDATE,
  ACTION_START_INSTALLATION,
  ACTION_UPDATE_INSTALLATION_PROGRESS,
} from './constants';

export const openUpdateModal = createAction(
  ACTION_OPEN_UPDATE_MODAL,
  (resolve) => (deviceId: number) => resolve({ deviceId })
);

export const closeUpdateModal = createAction(
  ACTION_CLOSE_UPDATE_MODAL,
  (resolve) => () => resolve()
);

export const setAvailableVersions = createAction(
  ACTION_SET_AVAILABLE_VERSIONS,
  (resolve) => (versions: string[]) => resolve({ versions })
);

export const selectVersion = createAction(
  ACTION_SELECT_VERSION,
  (resolve) => (version: string) => resolve({ version })
);

export const startCompatibilityCheck = createAction(
  ACTION_START_COMPATIBILITY_CHECK,
  (resolve) => () => resolve()
);

export const setUpdateStatus = createAction(
  ACTION_SET_UPDATE_STATUS,
  (resolve) => (status: UpdateStatus, errorMessage?: string) => resolve({ status, errorMessage })
);

export const setForceUpdate = createAction(
  ACTION_SET_FORCE_UPDATE,
  (resolve) => (enabled: boolean) => resolve({ enabled })
);

export const startInstallation = createAction(
  ACTION_START_INSTALLATION,
  (resolve) => () => resolve()
);

export const updateInstallationProgress = createAction(
  ACTION_UPDATE_INSTALLATION_PROGRESS,
  (resolve) => (progress: number) => resolve({ progress })
);
